/**
 * Project Type Badge Component
 */

import { Badge } from '@/components/ui/badge';
import { Wrench, Truck, TestTube, FileText, RefreshCw } from 'lucide-react';
import type { ProjectType } from '../types';

const TYPE_CONFIG: Record<ProjectType, { label: string; icon: typeof Wrench; className: string }> = {
  installation: {
    label: 'Installation',
    icon: Wrench,
    className: 'bg-blue-100 text-blue-800 hover:bg-blue-100 border-blue-200',
  },
  shipping: {
    label: 'Shipping',
    icon: Truck,
    className: 'bg-purple-100 text-purple-800 hover:bg-purple-100 border-purple-200',
  },
  calibration: {
    label: 'Calibration',
    icon: TestTube,
    className: 'bg-green-100 text-green-800 hover:bg-green-100 border-green-200',
  },
  replacement: {
    label: 'Replacement',
    icon: RefreshCw,
    className: 'bg-orange-100 text-orange-800 hover:bg-orange-100 border-orange-200',
  },
  quote: {
    label: 'Quote',
    icon: FileText,
    className: 'bg-amber-100 text-amber-800 hover:bg-amber-100 border-amber-200',
  },
};

interface ProjectTypeBadgeProps {
  type: ProjectType;
  showIcon?: boolean;
  className?: string;
}

export function ProjectTypeBadge({ type, showIcon = true, className }: ProjectTypeBadgeProps) {
  const config = TYPE_CONFIG[type] || { label: type, icon: Wrench, className: '' };
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={`${config.className} ${className || ''}`}>
      {showIcon && <Icon className="mr-1 h-3 w-3" />}
      {config.label}
    </Badge>
  );
}
